/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Code_PlaceholderInputs */

const en_password_reset_code_placeholder = /** @type {(inputs: Password_Reset_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code (check your email)`)
};

const es_password_reset_code_placeholder = /** @type {(inputs: Password_Reset_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código (revisa tu correo)`)
};

/**
* | output |
* | --- |
* | "Code (check your email)" |
*
* @param {Password_Reset_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_code_placeholder = /** @type {((inputs?: Password_Reset_Code_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Code_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_code_placeholder(inputs)
	return en_password_reset_code_placeholder(inputs)
});